import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgReturn32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M14.777 16.08a.5.5 0 1 1-.554.832l-6-4.002a.595.595 0 0 1-.04-.03l-.008-.006-.023-.02-.011-.012-.016-.018a.549.549 0 0 1-.02-.023l.02.024a.502.502 0 0 1-.123-.283l-.001-.024L8 12.494c0-.072.015-.144.046-.21l.018-.036a.702.702 0 0 1 .008-.013l-.026.05a.497.497 0 0 1 .075-.117l.02-.022.011-.011.018-.016c.008-.007.01-.01.014-.012l-.014.012a.51.51 0 0 1 .05-.04l6.003-4.003a.5.5 0 0 1 .554.832l-4.627 3.086H19a5.998 5.998 0 0 1 5.996 5.778l.004.225A6.004 6.004 0 0 1 19 24H9a.5.5 0 0 1 0-1h10a4.999 4.999 0 0 0 5-5.003 5.004 5.004 0 0 0-5-5.003h-8.848z" /></SvgIcon>;
};
const Memo = memo(SvgReturn32);
export default Memo;